export const STORAGE_TYPE_CODES: string[] = [
    '203', '226', '219', '213', '216', '230', '20B', '236', '209', '200', '202', '220', '260', '204', '212', '210'
];

export const DATE_FORMAT = 'dd-MM-yyyy';

export const DATE_TIME_FORMAT = 'dd-MM-yyyy, h:mm a';

export const MAX_FILE_SIZE = 15 * 1024 * 1024;

export const YES_NO_OPTIONS = [
    { text: 'Yes', value: true },
    { text: 'No', value: false },
];

export enum UserRole {
    Administrator = "Administrator",
    NestleManager = "Nestle Manager",
    HopewellSupervisor = "Hopewell Supervisor",
    Supplier = "Supplier",
    Carrier = "Carrier",
    Vendor = "Vendor",
    Customer = "Customer",
    Finance = "Finance",
    Agency = "Agency",
    WarehouseEmployee = "Warehouse Employee",
    OfficeEmployee = "Office Employee",
    AgencyEmployee = "Agency Employee",
}
